import { CommonModule } from '@angular/common';
import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { HeaderConfigService, OnDestroyBase } from '@os-components';
import { SewWsSocialMedia } from '@sew/ui-components-angular/standalone';
import { filter, takeUntil } from 'rxjs/operators';
import { environment } from '../../../../../environments/environment';

@Component({
    selector: 'blog-social-media',
    templateUrl: './social-media.component.html',
    styleUrls: ['./social-media.component.scss'],
    imports: [CommonModule, SewWsSocialMedia],
})
export class SocialMediaComponent extends OnDestroyBase implements OnInit, OnDestroy {
    @Input() public headline?: string;

    public language?: string;
    public countryShort?: string;
    public caasBaseUrl = environment.caas.baseUrl;

    public constructor(private configService: HeaderConfigService) {
        super();
    }

    public ngOnInit(): void {
        this.configService.countryShort
            .pipe(
                filter((countryShort) => countryShort.length > 0),
                takeUntil(this.destroySubject)
            )
            .subscribe((countryShort) => (this.countryShort = countryShort));

        this.configService.language
            .pipe(
                filter((language) => language.length > 0),
                takeUntil(this.destroySubject)
            )
            .subscribe((language) => (this.language = language));
    }
}
